import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ApiAwards } from '../config/api.component';

@Component({
  selector : 'exq-home',
  templateUrl : './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent {
  
  countdays: any;
  countseconds: any;
  countminutes: any;
  counthours: any;
  expCounter:number = 0;
  currentTime: number =  Date.now();
  totalVotes:number = 0;
  totalVoters:number = 0;
  totalVenues:number = 0;
  totalCategories:number = 0;
  dataCounters:any;
  listImages=[];
  wordingHTML:any;
  youtubeURL:SafeResourceUrl;
  imgWording:any;
  loadedVideo: boolean = false;
  instagram:string = "";
  tiktok:string = "";
  facebook: string = "";
  youtube:string = "";

  constructor(private api: ApiAwards, private sanitizer: DomSanitizer){

    this.api.getGeneral().subscribe(
      val => {
        console.log(val.json().data[0].video_link)
        this.wordingHTML = val.json().data[0].text_home;
        this.imgWording = val.json().data[0].images_url;
        this.instagram = val.json().data[0].instagram;
        this.tiktok = "https://www.tiktok.com/@exquisite.media?_t=8oV9NRvz1ld&_r=1";
        this.facebook = val.json().data[0].facebook;
        this.youtube = val.json().data[0].youtube;
        this.youtubeURL = this.sanitizer.bypassSecurityTrustResourceUrl(val.json().data[0].video_link);
      },
      error => {
        // console.log(error);
      },
      () => {
        this.loadedVideo = true;
        // console.log("Success");
      }
    )

    // this.api.getCategories().subscribe(
    //   value => {
    //     let dataVal = value.json().data;
    //     for (let i = 0; i < dataVal.length; i++) {
    //       if(dataVal[i].status === true){
    //         this.totalCategories ++;
    //       }          
    //     }
    //   },
    //   error => {},
    //   () => {})


    this.api.getCounters().subscribe(
      val =>{
        this.dataCounters = val.json().data;
        this.totalVotes = val.json().data.total_votes;
        this.totalVoters = val.json().data.total_voters;
        // this.totalVenues = val.json().data.total_venues;
        this.totalVenues = val.json().data.total_active_venues;
        this.totalCategories = val.json().data.total_categories;
        this.expCounter = this.dataCounters.exp_counter;
        // console.log(this.expCounter);
      },
      error =>{
        // console.log(error);
      },
      ()=>{
        // console.log("Success");
        var timeinterval = setInterval(() => {
          this.countdays = this.getTimeRemaining(this.expCounter).days;
          this.counthours = this.getTimeRemaining(this.expCounter).hours;
          this.countminutes = this.getTimeRemaining(this.expCounter).minutes;
          this.countseconds = this.getTimeRemaining(this.expCounter).seconds;

          if (this.countdays < 0) {
            this.countdays = 0;
          }
          if (this.counthours < 0) {
            this.counthours = 0;
          }
          if (this.countminutes < 0) {
            this.countminutes = 0;
          }
          if (this.countseconds < 0) {
            this.countseconds = 0;
          }

          if (this.getTimeRemaining(this.expCounter).total <= 1) {
            clearInterval(timeinterval);
          }
        }, 1000);
      }  
    );

    // Update the count down every 1 second
    // setInterval(() => {

    //   // Get todays date and time
    //   var now = new Date().getTime();

    //   // Find the distance between now and the count down date
    //   var distance = countDownDate - now;

    //   // Time calculations for days, hours, minutes and seconds
    //   // this.days = Math.floor(distance / (1000 * 60 * 60 * 24));

    // }, 1000);

    // this.api.getFVoters().subscribe(
    //   val => {
    //     //console.log(val.json());
    //     this.totalFVoters = val.json().data[0].voters;
    //   },
    //   error => {
    //     //console.log(error);
    //   },
    //   () => {

    //     this.api.getTotalVoters().subscribe(
    //       val=>{
    //         //console.log(val.json());
    //         this.totalVoters = val.json().data.total_voter + this.totalFVoters;
    //         this.totalLists = val.json().data.total_list;
    //       },
    //       error=>{
    //         //console.log(error);
    //       },
    //       ()=>{}
    //     );

    //   }
    // );

  }

  ngOnInit(){
    this.api.getSponsors().subscribe(
      val => {
        this.listImages = val.json().data;
      },
      error => { },
      () => { });
  }

  getTimeRemaining(endtime:number) {
    var now = new Date().getTime()
    var t = endtime - now;
    var seconds = Math.floor((t / 1000) % 60);
    var minutes = Math.floor((t / 1000 / 60) % 60);
    var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
    var days = Math.floor(t / (1000 * 60 * 60 * 24));
    return {
      'total': t,
      'days': days,
      'hours': hours,
      'minutes': minutes,
      'seconds': seconds
    };
  }
}
